import { Fragment } from "react";

import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { AvatarInput } from "@dzambalaorg/mui-inputs-image-firebase";
import { MerchantStatus, RatePlanType } from "@framework/types";
import { DialogMode } from "@framework/shared";

export interface IMerchantDialogFormProps {
  mode: DialogMode;
}

export const MerchantDialogForm = (props: IMerchantDialogFormProps) => {
  const { mode } = props;

  return (
    <Fragment>
      <TextInput name="title" />
      <RichTextEditor name="description" />
      <TextInput name="email" autoComplete="username" />
      {mode === "edit" && <SelectInput name="merchantStatus" options={MerchantStatus} />}
      {mode === "edit" && <SelectInput name="ratePlan" options={RatePlanType} />}
      <TextInput name="wallet" />
      <AvatarInput name="imageUrl" />
    </Fragment>
  );
};
